interface SkeletonProps {
  variant?: 'text' | 'title' | 'card' | 'avatar' | 'button' | 'input' | 'textarea' | 'template-card' | 'table-row' | 'sidebar-item' | 'circle';
  width?: string;
  height?: string;
  className?: string;
}

const variantClasses: Record<string, string> = {
  text: 'h-3.5 w-full mb-2',
  title: 'h-5 w-2/5 mb-3',
  card: 'h-[200px] rounded-card',
  avatar: 'w-12 h-12 rounded-full',
  button: 'h-10 w-[120px] rounded-btn',
  input: 'h-11 rounded-btn mb-4',
  textarea: 'h-[100px] rounded-btn mb-4',
  'template-card': 'h-[420px] rounded-card',
  'table-row': 'h-13 mb-1 rounded-btn',
  'sidebar-item': 'h-9 mb-2 rounded-btn w-full',
  circle: 'w-[120px] h-[120px] rounded-full',
};

export default function Skeleton({ variant = 'text', width, height, className = '' }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse bg-zinc-200 ${variantClasses[variant] || 'h-3.5 w-full mb-2'} ${className}`}
      style={{ width, height }}
    />
  );
}

export function DashboardSkeleton() {
  return (
    <div className="p-8">
      <Skeleton variant="title" />
      <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-6 mt-6 mb-12">
        <Skeleton variant="card" />
        <Skeleton variant="card" />
      </div>
      <Skeleton variant="title" width="200px" />
      <div className="grid grid-cols-[repeat(auto-fill,minmax(300px,1fr))] gap-6 mt-4">
        <Skeleton variant="card" />
        <Skeleton variant="card" />
        <Skeleton variant="card" />
      </div>
    </div>
  );
}

export function TemplatesGridSkeleton() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      <Skeleton variant="template-card" />
      <Skeleton variant="template-card" />
      <Skeleton variant="template-card" />
      <Skeleton variant="template-card" />
      <Skeleton variant="template-card" />
      <Skeleton variant="template-card" />
    </div>
  );
}

export function FormSkeleton() {
  return (
    <div className="max-w-[800px] mx-auto p-8">
      <Skeleton variant="title" />
      <Skeleton variant="text" />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
        <Skeleton variant="input" />
        <Skeleton variant="input" />
        <Skeleton variant="input" />
        <Skeleton variant="input" />
      </div>
      <Skeleton variant="textarea" />
      <Skeleton variant="textarea" />
    </div>
  );
}
